import { render, staticRenderFns } from "./AccountComponent.vue?vue&type=template&id=448deccb"
import script from "./AccountComponent.vue?vue&type=script&lang=js"
export * from "./AccountComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports